"use client";

import { Card, CardContent } from "@/components/ui/card";
import { useStep } from "@/hooks/use-step-handler";

import { AvsClientStep } from "../client/avs-client-step";

function VehicleAssignmentAvsSteps({
  onCanProceedChange,
}: {
  onCanProceedChange?: (canProceed: boolean) => void;
}) {
  const { step } = useStep();

  if (step === 3) {
    return <AvsClientStep onCanProceedChange={onCanProceedChange} />;
  }

  return (
    <Card>
      <CardContent className="p-6 text-gray-600">
        Contenu étape {step} (WIP)
      </CardContent>
    </Card>
  );
}

export { VehicleAssignmentAvsSteps };
